import { utilsMixin } from "./utils";
import { i18n } from "../../../main";

const d3 = require("d3");
import Globals from "./../../globals";
import cacheService from "@/services/cache";
// import ImageSvgCache from './../../../cache/ImageSvgCache'

export const componentMixin = {
    mixins: [utilsMixin],
    methods: {
        createModule(mod) {
            if (!mod.src) {
                mod.src = "/uploads/components/module-default.svg";
            }
            return this.eltSvg(mod.src)
                .then(domXml => {
                    if (domXml === null) return null;
                    let rect = this.getRectByPosition(mod.posX, mod.posY);
                    if (rect) {
                        let rectData = d3.select(rect).data()[0];

                        // this.addModule(domXml) // todo a ajouter dans le plano
                        d3.select(domXml)
                            .data([mod])
                            // .raise()
                            .attr("width", rectData.width * mod.size.width)
                            .attr("height", rectData.height * mod.size.height)
                            .attr("class", "grab module_snap")
                            .attr("x", d => {
                                d.x = rectData.x;
                                d.posX = rectData.posX;
                                return d.x;
                            })
                            .attr("y", d => {
                                d.y = rectData.y;
                                d.posY = rectData.posY;
                                return d.y;
                            })
                            .attr("id", mod.UUID);

                        // module.on('click', this.selectionModule)
                        this.loadCommentBadge(domXml, this.getCommentsStatus);
                        this.createVirtualComponent(domXml);
                        this.moduleStatus(domXml);

                        return { module: mod, elt: domXml };
                    } else {
                        console.error("La position du module est fausse " + mod.id + " pos x: " + mod.posX + " pos x: " + mod.posY);
                        return null;
                    }
                })
                .catch(e => {
                    console.error(e);
                    mod.src = null;
                    return this.createModule(mod);
                });
        },
        loadConstructTicket(svg, config) {
            let tickets = config.tickets;
            tickets.forEach(ticket => {
                d3.select(svg)
                    .select("#TICKET_STRIPS")
                    .select("#" + ticket.idElt)
                    .classed("selected", true);
            });
        },
        loadConstructPath(svg, config) {
            let i = 0;
            let validPath = d3.select(svg).select("g#FILL");

            validPath.selectAll("path").select(function() {
                d3.select(this).attr("id", "path_" + i);
                i = i + 1;
            });
            if (config && config.groups) {
                let self = this;
                let rowId;

                self._.forEach(config.groups, function(ensemble, k) {
                    rowId = "row_" + (k + "" + 1);
                    ensemble.rowId = rowId;
                    let d3E = validPath
                        // .data([{tester: ensemble.tester}])
                        .append("g")
                        .attr("id", rowId);
                    // ensemble.rowId = rowId
                    self._.forEach(ensemble.modules, function(path, kk) {
                        let temp = d3.select(svg).select("#" + path);
                        if (temp.size() > 0) {
                            temp.classed("grouped", true).classed(rowId, true);
                            if (path === ensemble.tester) {
                                ensemble.tester = path;
                                temp.classed("tester", true); // .attr('id', 'row_tester_' + k + '_' + kk)
                            }
                            d3E.append(function() {
                                return temp.node();
                            });
                        }
                    });
                    // self.ng = k + 1
                });
            }
        },
        getFontSizeNickName(size, nickname) {
            let countStr = nickname.length;
            let steps = {
                "30": 1,
                "25": 1,
                "20": 1.05,
                "15": 1.05,
                "10": 1.2,
                "5": 1.2
            };

            let res = 0;

            if (countStr <= 30 && countStr >= 26) {
                res = steps["30"];
            } else if (countStr <= 25 && countStr >= 21) {
                res = steps["25"];
            } else if (countStr <= 20 && countStr >= 16) {
                res = steps["20"];
            } else if (countStr <= 15 && countStr >= 11) {
                res = steps["15"];
            } else if (countStr <= 10 && countStr >= 5) {
                res = steps["10"];
            } else if (countStr <= 5 && countStr >= 0) {
                res = steps["5"];
            }

            let result = size / (countStr * res);
            // console.log(nickname, size, countStr, res, result, 'count')
            return result;
        },
        cleanModule(svg) {
            let texts = ["ETIQUETTE_TEXTES", "ETIQUETTE_TEXTE", "TEXTES", "TEXTS", "TEXT", "TEXTE_ETIQUETTE"];
            let etiquettes = ["ETIQUETTES", "ETIQUETTE"];

            etiquettes.forEach(eti => {
                d3.selectAll("g#" + eti).attr("id", "TICKET_STRIPS");
                d3.selectAll("g#" + eti.toLowerCase()).attr("id", "TICKET_STRIPS");
            });
            texts.forEach(text => {
                d3.selectAll("g#" + text).attr("id", "TEXTE");
                d3.selectAll("g#" + text.toLowerCase()).attr("id", "TEXTE");
            });

            let j = 1;
            d3.select(svg)
                .select("g#TICKET_STRIPS")
                .selectAll("rect")
                .each((d, i, cmps) => {
                    let cmp = cmps[i];
                    if (cmp.id === null || !cmp.id.startsWith("TICKET_STRIP_")) {
                        cmp.id = "TICKET_STRIP_" + j;
                        j++;
                    }
                    // if (cmp.id)
                });
            let d3T = d3.select(svg).select("#TEXTE");
            d3T.selectAll("text").remove();
        },
        loadConfigModule(svg, data, force = false) {
            let config = data.config;
            if (config) {
                this.loadConstructPath(svg, config);
                this.cleanModule(svg);
                this.loadColor(svg, data, force);
                this.preloadTextsIfNotTickets(svg, data);
                this.loadTicketStrips(svg, data, force);
                this.loadCommentBadge(svg, this.getCommentsStatus, data);
            }
        },
        preloadTextsIfNotTickets(svg, data) {
            let configText = this.getConfigText(data.config, svg);
            d3.select(svg)
                .select("g#TICKET_STRIPS")
                .selectAll("rect")
                .each((d, i, cmps) => {
                    this.loadTicketStripTexts(cmps[i], configText, true);
                });
        },
        loadTicketStripsByData(data, display) {
            let svg = document.querySelector("svg#builder svg#" + data.UUID);
            this.loadTicketStrips(svg, data, display);
        },
        loadTicketStrips(svg, data, display) {
            let config = data.config;
            let tickets = config.tickets;
            let eltTicketStrip, eltTicketStripD3;
            let ticket = null;
            // let url
            if (tickets) {
                tickets.forEach(ticketStrip => {
                    ticket = !ticketStrip.ticket ? null : ticketStrip.ticket;
                    eltTicketStripD3 = d3
                        .select(svg)
                        .select("g#TICKET_STRIPS")
                        .select("rect#" + ticketStrip.idElt);
                    eltTicketStrip = eltTicketStripD3.node();
                    // console.log(ticketStrip, '== t ===')
                    let ticketStripData = null;
                    if (ticketStrip.tickets.length === 1 && ticket === null) {
                        let ticketUnique = ticketStrip.tickets[0];
                        ticketStripData = this.loadTicketStrip(eltTicketStrip, ticket, ticketUnique, config);
                        if (ticketStrip) {
                            ticketStrip.ticket = ticketStripData.data;
                            this.loadTicketStripTexts(eltTicketStrip, config);
                        }
                    } else if (ticket !== null) {
                        ticketStripData = this.loadTicketStrip(eltTicketStrip, ticket, null, config);
                    }

                    if (ticketStripData) {
                        display = this.getViewsActive.includes("ticketstrip") || display;
                        ticketStripData.img.attr("visibility", display ? "visible" : "hidden");
                    }
                });
            }
        },
        // updateConfigText (config) {
        //     console.log(config, 'update config text')
        // },
        loadTicketStrip(eltRectTicketStrip, ticketSelected, ticketStrip = null, config) {
            this.loadTicketStripTexts(eltRectTicketStrip, config);
            // let parentNode = eltRectTicketStrip.parentNode
            if (ticketSelected === null) {
                // let url = this.getPathImageComponent(ticketStrip, 5)
                let bbRect = eltRectTicketStrip.getBBox();
                ticketSelected = this.createDataTicketStrip(ticketStrip, bbRect);
            } else if (ticketStrip) {
                let url = this.getPathImageComponent(ticketStrip);
                ticketSelected.id = ticketStrip.id;
                ticketSelected.url = url;
            }

            let img = null;
            if (ticketSelected) {
                img = this.createTicketStrip(eltRectTicketStrip, Globals.getBaseUrl() + ticketSelected.url);
            }

            return { img: img, data: ticketSelected };
        },
        createDataTicketStrip(ticketStrip, bbRect) {
            let url = this.getPathImageComponent(ticketStrip);
            let ticketData = {
                id: ticketStrip.id,
                x: bbRect.x,
                y: bbRect.y,
                width: bbRect.width,
                height: bbRect.height,
                url: url,
                nickname: Globals.getValueObject(ticketStrip, "terms.nickname", null)
            };

            return ticketData;
        },
        createTicketStrip(eltRectTicketStrip, url) {
            let bbRect = eltRectTicketStrip.getBBox();
            let parentNode = eltRectTicketStrip.parentNode;
            let img = null;
            img = d3.select(parentNode).select("image#image-" + eltRectTicketStrip.id);
            if (img.size() === 0) {
                img = d3
                    .select(parentNode)
                    .append("image")
                    .attr("id", "image-" + eltRectTicketStrip.id)
                    .attr("class", "image-ticket-strip")
                    .attr("xlink:href", url)
                    .attr("x", bbRect.x)
                    .attr("y", bbRect.y)
                    .attr("width", bbRect.width)
                    .attr("height", bbRect.height)
                    .raise();
            } else {
                img.attr("xlink:href", url).raise();
            }
            return img;
        },

        getConfigText(config, svg = null) {
            let refs = null;
            let name = {};

            if (config.texts) {
                if (config.texts.refs) refs = config.texts.refs;
            }

            let hasTickets = false;

            if (config.tickets) {
                let ticks = config.tickets.filter(ticket => {
                    return ticket.ticket || ticket.tickets.length === 1;
                });

                hasTickets = ticks.length > 0;
            }

            // console.log(hasTickets, 'hasticket')
            if (hasTickets) {
                let ticketSelected;
                config.tickets.forEach(ticket => {
                    ticketSelected = ticket.ticket;
                    if (ticketSelected) {
                        let nicknameTmp = ticketSelected.nickname;
                        // console.log(ticketSelected.nickname)
                        let nickname = {};
                        if (nicknameTmp) {
                            let langs = Object.keys(nicknameTmp);
                            langs.forEach(lang => {
                                nickname[lang] = nicknameTmp[lang].value;
                            });
                            // console.log(nicknameTmp, 'nickname tmp')
                        } else {
                            nickname["fr"] = ticketSelected.nickname;
                            nickname["en"] = ticketSelected.nickname;
                        }
                        name[ticket.idElt] = nickname;
                    } else {
                        name[ticket.idElt] = null;
                    }
                });
            } else if (svg !== null) {
                let rects = d3
                    .select(svg)
                    .select("g#TICKET_STRIPS")
                    .selectAll("rect");
                rects.each((d, i, cmps) => {
                    let cmp = cmps[i];
                    name[cmp.id] = Globals.getValueObject(config, "texts.name", "");
                });
            }

            let configTexts = {
                refs: refs,
                name: name
            };

            return configTexts;
        },
        loadTicketStripTexts(eltRectTicketStrip, config, putConfigText = false) {
            let configTexts = putConfigText ? config : this.getConfigText(config);
            let bbRect = eltRectTicketStrip.getBBox();
            let idELtTicket = eltRectTicketStrip.id;
            let parentNode = eltRectTicketStrip.parentNode;
            let refs = configTexts ? configTexts.refs : null;
            let names = configTexts ? configTexts.name : null;
            let name = names[eltRectTicketStrip.id];
            // console.log(configTexts, 'config text', eltRectTicketStrip.id)
            let size = bbRect.width;
            if (name) {
                let nickname = name instanceof String || !name ? name : name[i18n.locale];
                nickname = nickname ? nickname.substr(0, 29).toUpperCase() : "empty nickname";

                let fontSize = this.getFontSizeNickName(size, nickname);
                //         // console.log(fontSize)
                // fontSize = size / 2.5

                let textNodeD3 = d3.select(parentNode).select("text.text-nickname-" + idELtTicket);
                if (textNodeD3.size() === 0) {
                    textNodeD3 = d3
                        .select(parentNode)
                        .append("text")
                        .attr("class", "text-nickname-" + idELtTicket)
                        .attr("font-size", fontSize)
                        .style("font-size", fontSize)
                        .attr("x", bbRect.x + bbRect.width / 2)
                        // .attr('y', (bbRect.y + fontSize))
                        // .attr('width', rectCoords.width)
                        // .attr('height', rectCoords.height)
                        .attr("alignment-baseline", "ideographic")
                        .attr("text-anchor", "middle");
                }
                textNodeD3.text(nickname);

                let bbText = textNodeD3.node().getBBox();
                textNodeD3.attr("y", bbRect.y + bbText.height);
            }

            if (refs) {
                let fontSize = 10;
                let xTDiam = refs.DIAM.length * (fontSize / 2.5);
                let xTClient = refs.client.length * (fontSize / 2.5);

                let textRefDiam = d3.select(parentNode).select("text.refs-diam-" + idELtTicket);
                if (textRefDiam.size() === 0) {
                    d3.select(parentNode)
                        .append("text")
                        .raise()
                        .attr("class", "refs-diam-" + idELtTicket)
                        .attr("font-size", fontSize)
                        .attr("x", bbRect.x + bbRect.width - xTDiam)
                        .attr("y", bbRect.y + bbRect.height)
                        // .attr('width', bbRect.width)
                        // .attr('height', bbRect.height)
                        .attr("alignment-baseline", "ideographic")
                        .attr("text-anchor", "middle")
                        .text(refs.DIAM);
                }

                let textRefClient = d3.select(parentNode).select("text.refs-client-" + idELtTicket);
                if (textRefClient.size() === 0) {
                    d3.select(parentNode)
                        .append("text")
                        .raise()
                        .attr("class", "refs-client-" + idELtTicket)
                        .attr("font-size", fontSize)
                        .attr("x", bbRect.x + xTClient)
                        .attr("y", bbRect.y + bbRect.height)
                        // .attr('width', bbRect.width)
                        // .attr('height', bbRect.height)
                        .attr("alignment-baseline", "ideographic")
                        .attr("text-anchor", "middle")
                        .text(refs.client);
                }
            }
        },
        loadColor(svg, data, force = false) {
            if (force === false) this.moduleBlackWhite(svg, this.getViewsActive.includes("color") === false);
            if (!data.config) {
                return;
            }
            if (!data.config.groups) {
                return;
            }
            let configs = data.config.groups;
            let color;
            let paths;
            let parent;

            configs.forEach(config => {
                color = config.color;
                if (color !== null && color !== undefined) {
                    if (color.color) {
                        color.color = color.color.replace(new RegExp(" ", "g"), "").replace(new RegExp("&nbsp;", "g"), "");
                    }
                    // console.log(color, '=====')
                    parent = d3.select(svg).select("g#" + config.rowId);
                    paths = parent.selectAll("path");
                    // console.log(paths)
                    paths.each((d, i, cmps) => {
                        this.pathColor(config, cmps[i], parent, force);
                    });
                }
            });
        },

        moduleBlackWhite(svg, make) {
            let mods = ["MODULES"];
            mods.forEach(mod => {
                d3.select(svg)
                    .selectAll("#" + mod)
                    .attr("id", "MODULE");
                d3.select(svg)
                    .selectAll("#" + mod.toLowerCase())
                    .attr("id", "MODULE");
            });
            let mRect = d3
                .select(svg)
                .select("#MODULE")
                .selectAll("rect");
            mRect.classed("bgWhite", make).attr("fill", "white");

            d3.select(svg)
                .select("#FILL")
                .selectAll("path")
                .classed("bgWhite", make);

            // d3.select(svg).select('#FILL').selectAll('text.text-ref-shade').remove()
        },
        pathOrigin(path) {
            let color = "#d3d3d3";
            path.attr("fill", color).style("fill", color);
        },
        highlightContextMenu(textClicked, config) {
            let items = [
                { color: "#41B4E8", label: { fr: "Bleu", en: "Blue" } },
                { color: "#FF0000", label: { fr: "Rouge", en: "Red" } },
                { color: "#8A2BE1", label: { fr: "Violet", en: "Violet" } },
                { color: "#FFD600", label: { fr: "Jaune", en: "Yellow" } },
                { color: "#008000", label: { fr: "Vert", en: "Green" } },
                { color: "#000000", label: { fr: "Aucun", en: "None" } }
            ];
            this.createHighlightMenu(items, textClicked, config);
        },

        createHighlightMenu(items, cmp, config) {
            const event = d3.event;
            d3.select("div.content-menu-item").remove();
            let contentMenu = document.createElement("div");

            contentMenu.className = "content-menu";
            contentMenu.style.left = event.clientX + "px";
            contentMenu.style.top = event.clientY + "px";
            items.forEach(item => {
                let itemElt = document.createElement("div");
                let colorBadge = document.createElement("span");
                colorBadge.className = "badgeColorHighlight";
                colorBadge.style = "background-color:" + item.color;

                itemElt.className = "menu-item";
                let label = item.label[i18n.locale];
                itemElt.appendChild(colorBadge);
                itemElt.appendChild(document.createTextNode(label));
                contentMenu.appendChild(itemElt);

                d3.select(itemElt).on("click", () => {
                    console.log();
                    this.setShadeHighlight(item.color, cmp, config);
                });
            });
            document.body.appendChild(contentMenu);
            d3.select("body").on("click", () => {
                d3.selectAll("div.content-menu").remove();
            });
        },
        setShadeHighlight(color, elt, config) {
            config.highlight = { color };
            let text = d3.select(elt);
            text.attr("fill", color);
        },
        pathColor(config, pathElt, parent, force = false) {
            let path = d3.select(pathElt);
            let color = config.color;
            parent.data([color]);
            let text = parent.select("text");
            if (this.getViewsActive.includes("ref") === false && force === false) {
                text.remove();
            }

            if (path.attr("class").includes("tester") && (this.getViewsActive.includes("ref") || force === true)) {
                path.raise();
                let bb = path.node().getBBox();
                path.attr("fill", "white").style("fill", "white");

                if (text.size() === 0) {
                    text = parent.append("text");
                    text.attr("class", "text-ref-shade");
                    text.on("contextmenu", (data, i, elts) => {
                        d3.event.preventDefault();
                        let textClicked = elts[i];
                        this.highlightContextMenu(textClicked, config);
                    });
                }

                let count = color.ref ? color.ref.length : 2;
                let fontSize = (bb.height < bb.width ? bb.height : bb.width) / count;
                let x = Math.round(bb.x + bb.width / 2);
                let y = Math.round(bb.y + (bb.height / 5) * 4);
                let textColor = config.highlight ? config.highlight.color : "black";
                text.raise()
                    .attr("x", x)
                    .attr("y", y)
                    .attr("font-size", fontSize)
                    .style("font-size", fontSize)
                    .attr("text-anchor", "middle")
                    .attr("fill", textColor)
                    .text(color.ref);
            } else {
                if (this.getViewsActive.includes("color") || force) {
                    if (color.color.includes("|")) {
                        let colors = color.color.split("|");
                        let len = colors.length;
                        let offsetAvg = 100 / len;
                        let offset = 0;
                        let grads = colors.map(color => {
                            offset += Math.round(offsetAvg);
                            return { color: color, offset: offset };
                        });

                        let idGrad = parent.node().id + "_grad" + (force ? "_force" : "");
                        let defs = parent.select("defs");
                        if (defs.size() === 0) {
                            parent
                                .append("defs")
                                .lower()
                                .append("linearGradient")
                                .attr("id", idGrad)
                                .attr("x1", "0%")
                                .attr("x2", "75%")
                                .attr("y1", "0%")
                                .attr("y2", "75%")
                                .selectAll("stop.stop-grad")
                                .data(grads)
                                .enter()
                                .append("stop")
                                .attr("class", "stop-grad")
                                .attr("offset", (d, i) => {
                                    return d.offset + "%";
                                    // return (i === 0 ? 60 : 100) + '%'
                                })
                                .attr("stop-color", d => {
                                    return d.color;
                                })
                                .attr("stop-opacity", 1);
                        }
                        // colors
                        path.node().removeAttribute("style");
                        let classStr = path.node().classList.toString();
                        let classes = classStr.split(" ");
                        classes.forEach(cl => {
                            if (cl !== "grouped" && !cl.includes("row_")) {
                                path.node().classList.remove(cl);
                            }
                        });
                        path.attr("fill", "url(#" + idGrad + ")");
                    } else {
                        path.attr("fill", color.color).style("fill", color.color);
                    }
                    // console.log(color.color, 'color path')
                } else {
                    this.pathOrigin(path);
                }
            }
        },
        loadCommentBadge(module, commentsStatusObject, data = null) {
            if (this.getMode === "plano") {
                let currentUser = cacheService.getRem3rchUser().user.id;
                let moduleD3 = d3.select(module);
                /* Remove all previous circles */
                moduleD3.select("circle.personalNoteCircle").remove();
                moduleD3.select("circle.commentCircle").remove();
                let moduleData = data === null ? moduleD3.data()[0] : data;

                /* This module hasn't comment object */
                let commentStatusObject = commentsStatusObject.find(status => status.UUID === moduleData.UUID);
                if (!commentStatusObject) {
                    return false;
                }
                /* Check if the personalNote var exist */
                if (commentStatusObject.commentPrivate && commentStatusObject.commentPrivate.find(user => user === currentUser)) {
                    moduleD3
                        .insert("rect")
                        .attr("class", "personalNoteCircle")
                        .attr("x", 100)
                        .attr("y", 810)
                        .attr("width", 55)
                        .attr("height", 55)
                        .attr("fill", "#8AB400");
                }
                /* Check if the actual user has read all comments for this module */
                if (commentStatusObject.commentStatus) {
                    let userHasSeenIt = commentStatusObject.commentStatus.find(status => status.user === currentUser);
                    if (!userHasSeenIt && commentStatusObject.commentStatus.length > 0) {
                        moduleD3
                            .insert("rect")
                            .attr("class", "commentCircle")
                            .attr("x", 20)
                            .attr("y", 810)
                            .attr("width", 55)
                            .attr("height", 55)
                            .attr("fill", "#41B4E8");
                    }
                }
            }
        },
        createVirtualComponent(module, type = null) {
            let modD3 = d3.select(module);
            let data = modD3.data()[0];

            if (type === "cancel") {
                data.visual = null;
                modD3.select("rect.ret-visual-component").remove();
                return;
            }
            if (type !== null) {
                data.visual = type;
            } else {
                type = data.visual;
            }
            let types = {
                blue: "#41B4E8",
                red: "#FF0000",
                purple: "#8A2BE2",
                yellow: "#FFD700",
                green: "#008000",
                cancel: "cancel"
            };
            let colorType = types[type];
            if (!colorType) return;

            if (!data.visual) return;
            let virtuelComp = modD3.select("rect.ret-visual-component");

            if (virtuelComp.size() === 0) {
                virtuelComp = modD3
                    .append("rect")
                    .attr("class", "ret-visual-component")
                    .attr("width", "100%")
                    .attr("height", "100%")
                    .attr("opacity", 0.3)
                    .raise();
            }
            if (type !== null) {
                if (colorType) virtuelComp.attr("fill", colorType);
            }
            if (this.optionhidehighlight) {
                d3.select("#meubleInt")
                    .selectAll("rect.ret-visual-component")
                    .attr("visibility", this.optionhidehighlight ? "hidden" : "visible");
            }
        },
        moduleStatus(module) {
            let modD3 = d3.select(module);
            let data = modD3.data()[0];
            if (!data.status) return;
            /*  TODO => Remove color from here and use the one declared in the store */
            let color = null;
            switch (data.status) {
                case "in_progress":
                    color = "#836eb8";
                    break;
                case "new":
                    color = "#D60000";
                    break;
                default:
                    color = "blue";
                    break;
            }
            modD3
                .append("rect")
                .attr("class", "")
                .attr("width", "100%")
                .attr("height", "100%")
                .attr("fill", color)
                .attr("opacity", 0.5)
                .raise();
        },
        getKey(api) {
            let strs = api.split("/");
            let str = strs[strs.length - 1];
            return "image_" + str.replace(".");
        },
        eltSvg(api) {
            let url = this.getCleanUrl(api);
            let promise = new Promise((resolve, reject) => {
                d3.xml(url)
                    .mimeType("image/svg+xml")
                    .get((error, xml) => {
                        if (error) {
                            console.error(error, url, "error de le cache image");
                            reject(url);
                        } else {
                            resolve(xml.documentElement);
                        }
                    });
            });
            return promise;
        }
    }
};



// WEBPACK FOOTER //
// ./src/components/plano/mixins/component.js